export default {
  sfiPartnerKeyDefault: 'sfi',
  prettyScheduleMap: {
    inputRegEx: /([A-Z]{3})-?([A-Z]{3})?,([1-2]?[0-9]:[0-5][0-9] [AP]M)-([1-2]?[0-9]:[0-5][0-9] [AP]M)/,
    days: {
      MON: ['Monday', 'M'],
      TUE: ['Tuesday', 'T'],
      WED: ['Wednesday', 'W'],
      THU: ['Thursday', 'Th'],
      FRI: ['Friday', 'F'],
      SAT: ['Saturday', 'Sat'],
      SUN: ['Sunday', 'Sun']
    },
    AM: ['a.m.', 'am'],
    PM: ['p.m.', 'pm'],
    timezone: 'ET'
  }
}



// WEBPACK FOOTER //
// ./src/constants.js